import { multipleTypes } from "../../../constants/input-types";

export const hasGoalQuestionValue = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "number") return true;
  return Boolean(value);
};

export const getGoalQuestionValue = (question, goalInputs = {}) => {
  const savedValue = goalInputs?.[question.key];

  if (savedValue == null || savedValue?.includes?.("none")) {
    return question.value;
  }

  if (multipleTypes.includes(question.type)) {
    return savedValue?.[1] ?? savedValue ?? [];
  }

  if (Array.isArray(savedValue)) {
    return savedValue[1] ?? savedValue[0] ?? question.value;
  }

  return savedValue;
};
